module.exports = __webpack_public_path__ + "documents/VZPH_W_Terms_of_Service.pdf";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/termspage/pdf/VZPH_W_Terms_of_Service.pdf
// module id = 3531
// module chunks = 0